import { StudioFinderPagination } from './StudioFinderPagination'

export default StudioFinderPagination
